export default __webpack_public_path__ + "static/media/file-lightBlue.a764165d.svg";